<template>
  <div class="app-container">
    <el-card>
      <div slot="header">
        <h3>Aktywne integracje</h3>
        <p>Lista wszystkich aktywnych kont FTP</p>
      </div>

      <el-table 
        v-loading="loading" 
        :data="integrations" 
        border 
        style="width: 100%"
      >
        <el-table-column label="Użytkownik" min-width="200">
          <template slot-scope="scope">
            <div class="user-cell">
              <div class="user-name">{{ scope.row.user.name }}</div>
              <div class="user-email">{{ scope.row.user.email }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Login FTP" width="200">
          <template slot-scope="scope">
            <code>{{ scope.row.ftp_login }}</code>
          </template>
        </el-table-column>

        <el-table-column label="Status" width="120" align="center">
          <template slot-scope="scope">
            <el-tag 
              :type="isActive(scope.row) ? 'success' : 'info'" 
              size="small"
            >
              {{ isActive(scope.row) ? 'Aktywne' : 'Wyłączone' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="Akcje" width="150" align="center">
          <template slot-scope="scope">
            <el-button 
              :type="isActive(scope.row) ? 'warning' : 'success'" 
              size="small" 
              @click="handleToggle(scope.row)"
            >
              {{ isActive(scope.row) ? 'Wyłącz' : 'Włącz' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import IntegrationResource from '@/api/integration';

const integrationResource = new IntegrationResource();

export default {
  name: 'ActiveIntegrations',
  data() {
    return {
      loading: false,
      integrations: [],
    };
  },
  mounted() {
    this.loadIntegrations();
  },
  methods: {
    async loadIntegrations() {
      this.loading = true;
      try {
        const response = await integrationResource.getIntegrations();
        this.integrations = response.data || [];
      } catch (error) {
        console.error('Error loading integrations:', error);
        this.$message.error('Błąd podczas ładowania integracji');
      } finally {
        this.loading = false;
      }
    },

    // Integracja nie ma pola is_active - źródłem prawdy jest status 'active'|'inactive' (tak czyta go import).
    isActive(integration) {
      return integration.status === 'active';
    },

    async handleToggle(integration) {
      const wasActive = this.isActive(integration);
      const action = wasActive ? 'wyłączyć' : 'włączyć';
      try {
        await this.$confirm(`Czy na pewno chcesz ${action} tę integrację?`, 'Potwierdzenie', {
          confirmButtonText: 'Tak',
          cancelButtonText: 'Anuluj',
          type: 'warning',
        });

        this.loading = true;
        await integrationResource.setIntegrationStatus(integration.id, wasActive ? 'inactive' : 'active');
        this.$message.success(`Integracja została ${wasActive ? 'wyłączona' : 'włączona'}`);
        await this.loadIntegrations();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Error toggling integration:', error);
          this.$message.error('Błąd podczas zmiany statusu');
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.user-cell {
  .user-name {
    font-weight: 600;
    color: #303133;
    margin-bottom: 3px;
  }

  .user-email {
    font-size: 12px;
    color: #606266;
  }
}

code {
  background: #f5f7fa;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
}
</style>
